import React from "react"
import quote from "../assets/quote.png"
import quote2 from "../assets/quote2.png"
import bnwimage from "../assets/parthdadbnw.jpg"
import { motion } from "framer-motion"
import { fadeIn, textVariant, slideIn, zoomIn } from "../utils/motion"
const Quote = ({ index }) => {
  return (
    <>
      <div className="quote-block max-w[1920px] px-[15px] md:px-[40px] lg:px-[60px] xl:px-[80px] 2xl:px-[100px] font-leading ">
        <div className="mt-16 sm:mt-20">
          <div className="blockquote-container bg-center bg-contain bg-no-repeat relative px-10 pt-20 lg:pt-32 xl:pt-36 2xl:pt-52  block w-full max-w-1024 mx-auto lg:max-w-1280 xl:max-w-1440" style={{backgroundImage : `url(${bnwimage})`}}>
          <div className="absolute inset-0 bg-black opacity-50"></div>
            <motion.span
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={fadeIn("right", "spring", 0.5, 0.6)}
              className="block w-[1px] gold h-3/4 absolute left-0 top-0 "
            ></motion.span>
            <motion.blockquote
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={zoomIn(index * 0.7, 0.6)}
              className="blockquote-block pl-[40px] md:pl-[60px] lg:pl-[80px] xl:pl-[100px] 2xl:pl-[130px]  max-w-1280px mx-auto relative inline-block text-left "
            >
              <motion.span
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={slideIn("up", "tween", 0.5, 0.6)}
                className="w-10 md:w-16 lg:w-20 xl:w-24 2xl:w-32 absolute left-[-5px]"
              >
                <img src={quote}></img>
              </motion.span>
              <div className="quote-text-wrapper relative pb-[10px] inline-block">
                <p className="quote-text text-2xl sm:text-3xl md:text-5xl xl:text-5xl 2xl:text-7xl  transform translate-y-1">
                  <span className="font-light">
                    Every{" "}
                    <motion.span
                      initial="hidden"
                      whileInView="show"
                      viewport={{ once: true }}
                      variants={textVariant(0.6)}
                      className="quote-title"
                    >
                      building{" "}
                    </motion.span>
                    is a prototype,
                  </span>
                  <br className="hidden lg:block" />
                  <span> no </span>
                  <span className="font-light">two </span>
                  <span>are </span>
                  <span>alike </span>
                  <span className="relative">
                   
                    <motion.span
                      initial="hidden"
                      whileInView="show"
                      viewport={{ once: true }}
                      variants={slideIn("down", "tween", 0.5, 0.6)}
                      className="w-10 md:w-16 lg:w-20 xl:w-24 2xl:w-32 absolute bottom-[-10px]   md:bottom-[-20px]  lg:bottom-[-40px]  xl:bottom-[-60px]"
                    >
                      <img src={quote2} className="ml-2"></img>
                    </motion.span>
                  </span>
                </p>
              </div>
              <motion.cite
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                variants={slideIn("left", "tween", index * 0.6, 0.5)}
                className="quote-cite mt-10 block"
              >
                <span className="quote-title text-xs sm:text-sm md:text-base lg:text-base xl:text-lg  tracking-widest inline-block">
                  <span className="letter pr-3">–</span>
                  <span className="letter pr-3">Rahul</span>
                  <span className="letter pr-3">Deshmukh</span>
                  
                </span>
              </motion.cite>
            </motion.blockquote>
          
          </div>
        </div>
      </div>{" "}
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={fadeIn("right", "spring", 0.5, 0.6)}
        className="gold w-3/5 h-[1px] mt-20 lg:mt-40  "
      ></motion.div>
    </>
  )
}
export default Quote
